import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SiteContentProvider } from "@/context/SiteContentContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import AIChatWidget from "@/components/AIChatWidget";

import Home from "@/pages/Home";
import Category from "@/pages/Category";
import ProductDetail from "@/pages/ProductDetail";
import DropPage from "@/pages/DropPage";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import OrderDetail from "@/pages/OrderDetail";
import MyOrders from "@/pages/MyOrders";
import SearchResults from "@/pages/SearchResults";
import ScrollToTop from "@/components/ScrollToTop";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VendorRegister from "@/pages/VendorRegister";
import VendorDashboard from "@/pages/VendorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import About from "@/pages/About";
import ReturnPolicy from "@/pages/ReturnPolicy";
import DeliveryPolicy from "@/pages/DeliveryPolicy";
import CustomerTerms from "@/pages/CustomerTerms";
import ExhibitorTerms from "@/pages/ExhibitorTerms";
import MarketplaceTerms from "@/pages/MarketplaceTerms";
import MetaCommerce from "@/pages/MetaCommerce";
import LegalDoc from "@/pages/LegalDoc";
import Grievance from "@/pages/Grievance";
import { useEffect } from "react";

function RazorpayLoader() {
  useEffect(() => {
    if (document.getElementById("razorpay-sdk")) return;
    const s = document.createElement("script");
    s.id = "razorpay-sdk"; s.src = "https://checkout.razorpay.com/v1/checkout.js"; s.async = true;
    document.body.appendChild(s);
  }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <SiteContentProvider>
        <CartProvider>
          <RazorpayLoader />
          <Navbar />
          <main className="min-h-[70vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/drops/:id" element={<DropPage />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orders" element={<MyOrders />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/orders/success/:id" element={<OrderSuccess />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/vendor-register" element={<VendorRegister />} />
              <Route path="/vendor" element={<VendorDashboard />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/about" element={<About />} />
              <Route path="/return-policy" element={<ReturnPolicy />} />
              <Route path="/delivery-policy" element={<DeliveryPolicy />} />
              <Route path="/customer-terms" element={<CustomerTerms />} />
              <Route path="/exhibitor-terms" element={<ExhibitorTerms />} />
              <Route path="/marketplace-terms" element={<MarketplaceTerms />} />
              <Route path="/meta-commerce" element={<MetaCommerce />} />
              <Route path="/legal/grievance" element={<Grievance />} />
              <Route path="/legal/:slug" element={<LegalDoc />} />
              <Route path="/refund-policy" element={<LegalDoc slug="returns-refunds" />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <AIChatWidget />
          <Toaster position="top-right" richColors />
        </CartProvider>
        </SiteContentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
